import React, { useState, useEffect, useContext } from 'react';

import DropDown from "../../../../lib/ui/dropdown/Dropdown";
import InputField from "../../../../lib/ui/inputs/Input";
import Button from "../../../../lib/ui/buttons/Button";
import { LangCtx } from "../../../../lib/context";
import diseases from "../../../../config/diseases.json";
import { validateCharecters } from '../../../../lib/validation';

const VisitReason = (props) => {
    const [reason, setReason] = useState("");
    const [desc, setDesc] = useState("");
    const { l } = useContext(LangCtx);
    const [error, setError] = useState("");
    const checkUnderScore = true;

    // useEffect(() => {
    //     let d = new Date().valueOf();
    //     getDoctorSlots(d).then(res => {
    //         console.log("res === ", res);
    //     }).catch(err => {
    //         console.log("err === ", err);
    //     })
    // }, []);
    useEffect(() => {
        props.formData && props.formData.reason ? setReason(props.formData.reason) : setReason("");
        props.formData && props.formData.description ? setDesc(props.formData.description) : setDesc("");
    }, [props.formData]);

    if (diseases && diseases[0].value !== "") {
        diseases.unshift({ value: "", label: l.reason_for_visit })
    }
    const handleNext = () => {
        if (reason && reason !== "") {
            if(desc.trim() !== '' && validateCharecters(desc.trim())){
                let obj = {
                    reason: reason,
                    description: desc
                }
                props.handleNext(obj, "FU");
            }else if(desc ===''){
                let obj = {
                    reason: reason,
                    description: desc
                }
                props.handleNext(obj, "FU");
            }else {
                setError(l.pls_enter_valid_desc);
            }
        } else {
            setError(l.pls_sel_reason);
        }
    }

    const handlePrev = () => {
        let obj = {
            reason: reason,
            description: desc
        }
        props.handleNext(obj, "TS");
    }

    // const setDescription=(e)=>{
    //     console.log('ee',e);
    //     if(validateCharecters(e.target.value)){
    //     }
    //     setDesc(e.target.value)
    // }


    return (
        <div className={props.active === "VR" ? "baColBlock secondChild secondChildSlide" : "baColBlock secondChild"}>
            <span className="subHdngTxt">{l.reas_for_call}</span>
            {error && error !== "" && <span className="redTxt errorTxt">{error}</span>}
            <div className="baChildColBlock">
                <DropDown
                    placeholder={l.select_reason}
                    items={diseases}
                    value={reason}
                    checkUnderScore={checkUnderScore}
                    onChange={(e) => setReason(e.target.value)}
                />
                <InputField
                    placeholder={l.reason_text}
                    type="text"
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                />

            </div>
            <div className="baFtrGtnGroup">
                <Button
                    size="md"
                    className="btn"
                    type="primary"
                    onClick={handlePrev}
                    label={l.previous}
                />
                <Button
                    size="md"
                    className="btn"
                    type="primary"
                    onClick={handleNext}
                    label={l.next}
                />
            </div>
        </div>
    )
}

export default VisitReason;